export const ITEMS_TO_DISPLAY = 5;

export type MenuProps = {
  menuData: Array<MenuItem> | [];
};

export type MenuItem = {
  parentId: number | null;
  id: number;
  name: string;
  url: string;
  html: string | null;
  sub: Array<MenuItem> | null;
};
